import { render } from "./Chip.vue?vue&type=template&id=02370393"
import script from "./Chip.vue?vue&type=script&lang=js"
export * from "./Chip.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__